exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-label-container[data-v-43f6a492]{display:block;width:35px;height:35px}.icon-label-btn[data-v-43f6a492]{font-size:18px;position:absolute;left:23.5%;top:20%}", ""]);

// exports
